const ScormRoute = ({ component: Component }) => {
    return <Component />;
};

export default ScormRoute;
